export interface TAIModelBuilderDatasetEntry {
  key: string;
  features_fr?: string[];
  features_en?: string[];
  features_ar?: string[];
}

export interface TAIModelBuilderDataTypeEntry {
  title_en?: string;
  title_fr?: string;
  title_ar?: string;
  status?: string;
}

export interface TAIModelBuilderLessonConfig {
  statement?: string;
  bruit_fr?: string[];
  bruit_en?: string[];
  bruit_ar?: string[];
  dataset: Record<string, TAIModelBuilderDatasetEntry>;
  data_type?: Record<string, TAIModelBuilderDataTypeEntry>;
}

export const createEmptyAIModelBuilderLessonConfig = (): TAIModelBuilderLessonConfig => ({
  dataset: {},
  bruit_ar: [],
  bruit_en: [],
  bruit_fr: [],
  data_type: {},
});
